export class AppSettings {
    public static APP_NAME = 'IrriMet';
    public static BASE_URL = 'https://apitest.irrimet.com.tr';
    public static API_ENDPOINT = AppSettings.BASE_URL + '/api/';
    public static PUBLICAPI_ENDPOINT = AppSettings.BASE_URL + '/publicapi/';
}
